import React, { useState, useEffect } from "react";
import "../App.css";
import { Link } from "react-router-dom";
import axios from "axios";


function Home() {
  const [showOptions, setShowOptions] = useState(false);
  axios.defaults.withCredentials = true;
  const handleButtonClick = () => {

    setShowOptions(true);
  };

  useEffect(() => {
    axios.get(process.env.REACT_APP_Apiurl +"checkSignIn").then((res) => {
      console.log(res)
      if(res.data.Authorized)
        window.location.href = process.env.REACT_APP_App_Url + "overview";
  });
  })
  

  return (
    <div className="flex items-center justify-center h-screen bg-[#121212] text-white">
      {!showOptions && (
        <div className="text-center transition-opacity opacity-100 duration-1000">
          <h1 className="font-bold text-2xl mb-2 opacity-100">
            UT Course Planner :O
          </h1>
          <a
            onClick={handleButtonClick}
            href="#_"
            className="relative inline-flex items-center justify-center p-4 px-6 py-3 overflow-hidden font-medium text-indigo-600 transition duration-300 ease-out rounded-full group opacity-100"
          >
            <span className="absolute inset-0 flex items-center justify-center w-full h-full text-[#FFD700] duration-300 -translate-x-full group-hover:translate-x-0 ease">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="absolute flex items-center justify-center w-full h-full text-[#FFD700] transition-all duration-300 transform group-hover:translate-x-full ease">
            Get Started
            </span>
            <span className="relative invisible">Get Started</span>
          </a>
        </div>
      )}

      {showOptions && (
        <div className="options-container">
          <Option to="../loadplan" text="Load Course Plan" delay={200} />
          {/* <Option to="../loadcollection" text="Load Collection" delay={400} /> */}
          <CreateButton text="Create Plan" delay={500} />
          {/* <Option to="../planner" text="Create Collection" delay={800} /> */}
          <Option to="../signIn" text="Google Sign In" delay={850} />
        
        </div>
      )}
    </div>
  );
}

function Option({ to, text, delay}) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return (
    <div
      className={`option py-1 px-4 opacity-0 transition-opacity duration-1000 ${
        show ? "opacity-100" : ""
      }`}
    >
      <Link
        to={to}
        className="relative inline-flex items-center justify-start py-2 pl-4 pr-12 overflow-hidden  text-gray-300 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 group"
      >
        <span className="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out group-hover:h-full"></span>
        <span className="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
          <svg
            className="w-5 h-5 text-[#FFDF00]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            ></path>
          </svg>
        </span>
        <span className="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
          <svg
            className="w-5 h-5 text-[#FFDF00]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            ></path>
          </svg>
        </span>
        <span className="relative w-full text-left transition-colors duration-200 ease-in-out">
          {text}
        </span>
      </Link>
    </div>
  );
}

function CreateButton({ text, delay}) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, delay);
    return () => clearTimeout(timer);
  }, [delay]);

  const createPlan = () => {
    axios.post(process.env.REACT_APP_Apiurl +"createplan").then((res) => {
      window.location.href = process.env.REACT_APP_App_Url + "planner/" + res.data.message;
    });
  };
  

  return (
    <div
      className={`option py-1 px-4 opacity-0 transition-opacity duration-1000 ${
        show ? "opacity-100" : ""
      }`}
    >
      <button
        onClick = {createPlan}
        className="relative inline-flex items-center justify-start py-2 pl-4 pr-12 overflow-hidden  text-gray-300 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 group"
      >
        <span className="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out group-hover:h-full"></span>
        <span className="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
          <svg
            className="w-5 h-5 text-[#FFDF00]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            ></path>
          </svg>
        </span>
        <span className="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
          <svg
            className="w-5 h-5 text-[#FFDF00]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            ></path>
          </svg>
        </span>
        <span className="relative w-full text-left transition-colors duration-200 ease-in-out">
          {text}
        </span>
      </button>
    </div>
  );
}

export default Home;
